import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class User  {
    _originalTypeClassName = "zAppDevManager.BO.User";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
User.translate = translateService;
}
this.UserLogins = [];
this.Activity = [];
this.Id = null;
this.Username = null;
this.Email = null;
this.VscPassword = null;
this.LockoutEnd = null;
this.DateRegistered = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Username:any;
Email:any;
VscPassword:any;
LockoutEnd:any;
DateRegistered:any;
UserLogins:any;
Activity:any;
static setUserLogins = ($this, items) => {
                if (items == null) items = [];
                if ($this.UserLogins == null) $this.UserLogins = [];

                const copyItems = Common.cloneObject(items);

                while ($this.UserLogins.length > 0) {
                    Domain.User.removeUserLogins($this, $this.UserLogins[0]);
                }

                Domain.User.addManyUserLogins($this, copyItems);
            }
static addManyUserLogins = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.User.addUserLogins($this, items[i]);
                }
            }
static addUserLogins = ($this, item) => {
                if ($this.UserLogins == null) $this.UserLogins = [];
                if (item == null || $this.UserLogins.indexOf(item) > -1) return;
                $this.UserLogins.push(item);
}
static addRangeUserLogins = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.User.addUserLogins($this, item));
            }
static removeUserLogins = ($this, item) => {
                if ($this == null || $this.UserLogins == null || $this.UserLogins.indexOf(item) === -1) return;
                var _index = $this.UserLogins.indexOf(item);
                $this.UserLogins.splice(_index, 1);
}
static clearUserLogins = ($this) => { $this.UserLogins = null; }
static setActivity = ($this, items) => {
                if (items == null) items = [];
                if ($this.Activity == null) $this.Activity = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Activity.length > 0) {
                    Domain.User.removeActivity($this, $this.Activity[0]);
                }

                Domain.User.addManyActivity($this, copyItems);
            }
static addManyActivity = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.User.addActivity($this, items[i]);
                }
            }
static addActivity = ($this, item) => {
                if ($this.Activity == null) $this.Activity = [];
                if (item == null || $this.Activity.indexOf(item) > -1) return;
                $this.Activity.push(item);
}
static addRangeActivity = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.User.addActivity($this, item));
            }
static removeActivity = ($this, item) => {
                if ($this == null || $this.Activity == null || $this.Activity.indexOf(item) === -1) return;
                var _index = $this.Activity.indexOf(item);
                $this.Activity.splice(_index, 1);
}
static clearActivity = ($this) => { $this.Activity = null; }

static SerializeRow(row: any): any{let s = new Domain.User();
s.Id = Joove.Common.cast(row.get("Id"), "number");
s.Username = Joove.Common.cast(row.get("UserName"), "string");
s.Email = Joove.Common.cast(row.get("Email"), "string");
if (row.has("DateRegistered")) {try {s.DateRegistered = Joove.Common.cast(row.get("DateRegistered"), "Date");}catch (e) {s.DateRegistered = null;}}
if (row.has("LockoutEnd")) {try {s.LockoutEnd = Joove.Common.cast(row.get("LockoutEnd"), "Date");}catch (e) {s.LockoutEnd = null;}}else {console.warn("No LockoutEnd column...");}
if (row.has("VscPassword")) {s.VscPassword = Joove.Common.cast(row.get("VscPassword"), "string");}
return s;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}